import { isNavItemActive } from "./isNavItemActive";
import type { NavItem, NavLocation } from "../types";

export const autoExpandedId = (
  items: NavItem[],
  location: NavLocation,
): string | undefined =>
  items.find(
    (item) =>
      item.children &&
      item.children.length > 1 &&
      isNavItemActive(item, location),
  )?.id;
